import { createOrder } from '@/api/cart';
import router from '@/router';
import { AxiosError } from 'axios';
import { ESeriesCategory, ESubscribeMode, IPlan } from '@reolink-cloud/interface';

interface ICreateFreePlanOrderResult {
    id: string;
}

export interface ICreateFreePlanOrderParams {
    plan: IPlan;
    isAddOn: boolean;
    lang: string;
    selectedCountry: string;
    iccid?: string;
    parentSubscriptionId?: string;
}

export interface IFreePlanClaimErrorResponse {
    error?: {
        metadata?: {
            reason?: string;
        };
    };
}

export async function createFreePlanOrder(
    {
        plan,
        isAddOn,
        lang,
        selectedCountry,
        iccid,
        parentSubscriptionId
    }: ICreateFreePlanOrderParams
): Promise<ICreateFreePlanOrderResult> {

    return createOrder(
        [{
            productId: plan.id,
            productType: plan.series?.category ?? ( isAddOn
                ? ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN
                : ESeriesCategory.CLOUD_DATA_PLAN ),
            qty: 1,
            context: {
                action: ESubscribeMode.CREATE,
                lang,
                associateDevices: [],
                unassociateDevices: [],
                associateSimCards: iccid ? [{
                    iccid
                }] : [],
                autoRenew: false,
                parentSubscription: isAddOn ? parentSubscriptionId : undefined
            }
        }],
        {},
        Number( plan.pricing.salePrice ).toFixed( 2 ),
        plan.pricing.currency,
        undefined,
        selectedCountry
    ) as Promise<ICreateFreePlanOrderResult>;

}

export const resolveFreePlanClaimError = ( error: unknown ): string => {

    const axiosError = error as AxiosError;
    const errorResponse = axiosError.response?.data as IFreePlanClaimErrorResponse | undefined;
    const reason = errorResponse?.error?.metadata?.reason;

    if ( reason === 'onlyOneFreePlan' ) {

        return 'errors.one_free_plan';

    }

    return 'errors.server_error';

};

export const goToFreePlanCompletePage = async ( orderId: string ): Promise<void> => {

    await router.push({
        path: '/free-sim-complete',
        query: {
            id: orderId,
            mode: ESubscribeMode.CREATE
        }
    });

};
